import { ENVIRONMENT } from "constants/environment"

export const requestEnvironmentAtmaca = (data: any) => ({
  ...data,
  environment: ENVIRONMENT,
})
